import type { MetricItem } from '@/types/api/dashboard'

interface NumberCardGroupWidgetProps {
  title: string
  metrics?: MetricItem[]
}

const CARD_STYLES = [
  { gradient: 'from-blue-500 to-indigo-500', bg: 'bg-blue-50/50', text: 'text-blue-700', icon: '▨' },
  { gradient: 'from-emerald-500 to-teal-500', bg: 'bg-emerald-50/50', text: 'text-emerald-700', icon: '▣' },
  { gradient: 'from-amber-500 to-orange-500', bg: 'bg-amber-50/50', text: 'text-amber-700', icon: '◆' },
  { gradient: 'from-purple-500 to-violet-500', bg: 'bg-purple-50/50', text: 'text-purple-700', icon: '◈' },
  { gradient: 'from-rose-500 to-pink-500', bg: 'bg-rose-50/50', text: 'text-rose-700', icon: '●' },
  { gradient: 'from-cyan-500 to-blue-500', bg: 'bg-cyan-50/50', text: 'text-cyan-700', icon: '■' },
  { gradient: 'from-teal-500 to-emerald-500', bg: 'bg-teal-50/50', text: 'text-teal-700', icon: '✦' },
  { gradient: 'from-violet-500 to-fuchsia-500', bg: 'bg-violet-50/50', text: 'text-violet-700', icon: '⬟' },
]

export function NumberCardGroupWidget({ title, metrics = [] }: NumberCardGroupWidgetProps) {
  return (
    <div className="flex h-full flex-col p-4">
      <p className="mb-4 text-xs font-semibold uppercase tracking-wider text-neutral-500">{title}</p>
      {metrics.length === 0 ? (
        <div className="flex flex-1 items-center justify-center">
          <p className="text-sm text-neutral-400">No metrics</p>
        </div>
      ) : (
        <div className="grid flex-1 gap-3 md:grid-cols-2 xl:grid-cols-4">
          {metrics.map((metric, index) => {
            const style = CARD_STYLES[index % CARD_STYLES.length]
            return (
              <div
                key={metric.label}
                className={`relative overflow-hidden rounded-xl ${style.bg} border border-white/60 p-4 shadow-sm transition-all duration-200 hover:shadow-md`}
              >
                <div className={`absolute inset-x-0 top-0 h-[3px] bg-gradient-to-r ${style.gradient}`} />
                <div className="flex items-center gap-2">
                  <span className={`text-lg ${style.text}`}>{style.icon}</span>
                  <p className="text-xs font-medium uppercase tracking-wide text-neutral-500">{metric.label}</p>
                </div>
                <p className={`mt-2 text-2xl font-bold tracking-tight ${style.text}`}>{String(metric.value)}</p>
              </div>
            )
          })}
        </div>
      )}
    </div>
  )
}
